export const PLACEMENTS = {
    TOP:    'top',
    BOTTOM: 'bottom',
    RIGHT:  'right',
    LEFT:   'left',

    TOP_START:    'top-start',
    BOTTOM_START: 'bottom-start',
    RIGHT_START:  'right-start',
    LEFT_START:   'left-start',

    TOP_END:    'top-end',
    BOTTOM_END: 'bottom-end',
    RIGHT_END:  'right-end',
    LEFT_END:   'left-end',
} as const;

export const OPPOSITE_PLACEMENTS = {
    [PLACEMENTS.TOP]:    PLACEMENTS.BOTTOM,
    [PLACEMENTS.BOTTOM]: PLACEMENTS.TOP,
    [PLACEMENTS.RIGHT]:  PLACEMENTS.LEFT,
    [PLACEMENTS.LEFT]:   PLACEMENTS.RIGHT,
} as const;

export const FALLBACK_PLACEMENTS = {
    [PLACEMENTS.TOP]:    [PLACEMENTS.BOTTOM, PLACEMENTS.LEFT, PLACEMENTS.RIGHT],
    [PLACEMENTS.BOTTOM]: [PLACEMENTS.TOP, PLACEMENTS.LEFT, PLACEMENTS.RIGHT],
    [PLACEMENTS.RIGHT]:  [PLACEMENTS.LEFT, PLACEMENTS.TOP, PLACEMENTS.BOTTOM],
    [PLACEMENTS.LEFT]:   [PLACEMENTS.RIGHT, PLACEMENTS.TOP, PLACEMENTS.BOTTOM],

    [PLACEMENTS.TOP_START]:    [PLACEMENTS.BOTTOM_START, PLACEMENTS.LEFT_END, PLACEMENTS.RIGHT_END],
    [PLACEMENTS.BOTTOM_START]: [PLACEMENTS.TOP_START, PLACEMENTS.LEFT_START, PLACEMENTS.RIGHT_START],
    [PLACEMENTS.RIGHT_START]:  [PLACEMENTS.LEFT_START, PLACEMENTS.TOP_END, PLACEMENTS.BOTTOM_END],
    [PLACEMENTS.LEFT_START]:   [PLACEMENTS.RIGHT_START, PLACEMENTS.TOP_START, PLACEMENTS.BOTTOM_START],

    [PLACEMENTS.TOP_END]:    [PLACEMENTS.BOTTOM_END, PLACEMENTS.LEFT_END, PLACEMENTS.RIGHT_END],
    [PLACEMENTS.BOTTOM_END]: [PLACEMENTS.TOP_END, PLACEMENTS.LEFT_START, PLACEMENTS.RIGHT_START],
    [PLACEMENTS.RIGHT_END]:  [PLACEMENTS.LEFT_END, PLACEMENTS.TOP_END, PLACEMENTS.BOTTOM_END],
    [PLACEMENTS.LEFT_END]:   [PLACEMENTS.RIGHT_END, PLACEMENTS.TOP_START, PLACEMENTS.BOTTOM_START],
};

export function isValid(placement: string) {
    // @ts-expect-error need for non typed use cases
    return Object.values(PLACEMENTS).includes(placement);
}
